// Grid state parts that only change where the focus is. They change on every click into
// a cell, so they must not redraw the cells: that would destroy an input or dropdown the
// user just clicked into and take its focus.
const FOCUS_ONLY_SOURCES = new Set(['focusedCell']);

export const onStateUpdatedEvent = ({ gridRef, onStateUpdated, params }) => {
  const {state, sources} = params;
  const {sort} = state;

  // Need to include params in the argument
  // NOTE: onSelectionChanged(params)
  if (onStateUpdated) onStateUpdated(sort?.sortModel);

  // Skip the redraw when only the focused cell changed. sources lists the state parts
  // that changed; when the grid doesn't provide it, redraw as before.
  const isFocusOnly = Array.isArray(sources) && sources.length > 0
    && sources.every((source) => FOCUS_ONLY_SOURCES.has(source));
  if (isFocusOnly) return;

  gridRef.current.api.refreshCells({ force: true });
};